//
//
//
//

export default {
	name: 'd2c',
}
